import React, {useEffect, useState} from 'react';
import styles from './PatientList.module.scss';
import {useNavigate} from 'react-router-dom';
import {TBody} from "../../../common/TActions/TBody";
import {TSort} from "../../../common/TSort/TSort";
import {PaginationBottom} from "../../../common/PaginationBottom/PaginationBottom";
import {commonServices} from "../../../../api/commonServices";
import {filterDate, searchOptions, tableTitle} from "./data";

const PatientList = () => {
    const navigate = useNavigate(); // Hook to navigate programmatically
    const [patients, setPatients] = useState([]); // State to hold patients data

    const [searchTerm, setSearchTerm] = useState(''); // State for the search term
    const [perPage, setPerPage] = useState(10); // State for items per page
    const [limit, setLimit] = useState(0); // Total number of items
    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const [action, setAction] = useState(0); // Delete

    const [filters, setFilters] = useState({
        name: '',
        lastName: '',
        middleName: '',
        gender: '',
        phoneNumber: '',
        cardNumber: '',
        patientNumber: '',
        birthDate: '',
        createdAt: '',
        updatedAt: '',
        offset: 0,
        limit: 10,
        sortBy: 'id', // Default sorting by id
    });

    // Handle filter change and reset pagination
    const handleFilterChange = (e) => {
        const {name, value} = e.target;
        setFilters({
            ...filters,
            [name]: value,
            offset: 0, // Reset pagination when filter changes
        });
        setCurrentPage(1);
    };

    // Unified useEffect for filtering, sorting, and pagination
    useEffect(() => {
        // Filter out empty filters
        const nonEmptyFilters = Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => value !== '')
        );

        const queryParams = new URLSearchParams(nonEmptyFilters).toString(); // Prepare query params for URL

        // Fetch patients based on filters
        commonServices.getByParam("/patient", queryParams).then(res => {
            if (res?.data){
                const result = res?.data?.data.map(({updatedAt, createdAt, birthDate, ageYears, ageMonths, ageDays, outside, ...rest }) => rest)?.map(el => ({...el,
                    gender: el?.gender == "male" ? 'чоловік' : "жінка"
                }));
                setPatients(result); // Set patients data
                setLimit(res?.data?.count); // Set total count of results
                navigate(`?${queryParams}`); // Update URL with filter parameters
            }
        });
    }, [filters, navigate, action]);

    // Handle change in the number of items per page
    const handleLimitChange = (e) => {
        const newPerPage = e.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            limit: newPerPage, // Update limit in filters
            offset: 0, // Reset pagination on limit change
        }));
        setPerPage(newPerPage);
        setCurrentPage(1); // Reset to first page
    };

    // Sort patients based on the selected field
    const sortByFilter = (sortField) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            sortBy: sortField, // Update sort field
            offset: 0, // Reset pagination on sorting
        }));

        setCurrentPage(1); // Reset to first page
    };

    // Handle page change for pagination
    const handlePaginationChange = (pageNum) => {
        const offset = pageNum * perPage; // Calculate offset based on page number
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: offset, // Update offset in filters
        }));
        setCurrentPage(pageNum + 1); // Update current page
    };

    useEffect(() => {
        setPatients((prevUsers) => prevUsers.filter(user => user.id !== action));
    }, [action])
    console.log(patients.map(({ id, ...rest }) => rest))
    return (
        <div className={styles['patient-page']}>
            <h1>Список пацієнтів</h1>
            <TSort searchTerm={searchTerm}
                   setSearchTerm={setSearchTerm}
                   setSortField={sortByFilter}
                   perPage={perPage}
                   handleLimitChange={handleLimitChange}
                   title={'Створити скерування'}
                   navigateUrl={'/FindPatientForm'}
                   searchOptions={searchOptions}
            />
            <div className={styles['table-wrapper']}>
                <table className={styles['patient-table']}>
                    <thead>
                    <tr>{tableTitle.map((header, index) =>
                        <th key={index}>{header}</th>)}</tr>
                    <tr>
                        {filterDate.map(({name, placeholder, type = 'text', options}, index) => (
                            <th key={index}>
                                {type == 'select' ? (
                                    <select name={name} value={filters[name]} onChange={handleFilterChange}>
                                        {options.map((option, optIndex) => (
                                            <option key={optIndex}
                                                    value={option}>{option == '' ? 'Всі' : option == 'male' ? 'Чоловік' : 'Жінка'}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type={type}
                                        name={name}
                                        value={filters[name]}
                                        onChange={handleFilterChange}
                                        placeholder={placeholder}
                                    />
                                )}
                            </th>
                        ))}
                        <th></th>
                    </tr>
                    </thead>
                    <TBody paginatedInfo={patients.map(({ id, ...rest }) => ({
                        patientNumber: rest.patientNumber,
                        ...rest
                    }))} navigateUrl={'/PatientCard'} setAction={setAction} deleteUrl={'patient'}
                           handleUrl={'EditPatient'} deleteTitle={"Пацієнта успішно видалено"}/>
                </table>
            </div>

            {/* Pagination component */}
            <PaginationBottom limit={limit} perPage={perPage} currentPage={currentPage} setCurrentPage={handlePaginationChange}/>
        </div>
    );
};

export default PatientList;